// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__1QL3a","infoBtn":"quickbooks_infoBtn__3Rl8l","formBox":"quickbooks_formBox__3jrp-","formFooter":"quickbooks_formFooter__3_9cY"};